__turbopack_context__.v({
  "aboutContent": "ZKd_5G_aboutContent",
  "aboutDetails": "ZKd_5G_aboutDetails",
  "intro": "ZKd_5G_intro",
  "introText": "ZKd_5G_introText",
  "introTitle": "ZKd_5G_introTitle",
  "tab": "ZKd_5G_tab",
  "tabBand": "ZKd_5G_tabBand",
  "tabsContainer": "ZKd_5G_tabsContainer",
  "tabsNavigationContainer": "ZKd_5G_tabsNavigationContainer",
});
